"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsContainer = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var React = require("react");
var search_1 = require("src/search");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var webexUI_1 = require("webexUI");
var FilterableDataLoader_1 = require("Views/Partials/Components/FilterableList/FilterableDataLoader");
var BaseFilterableListContainer_1 = require("Views/Partials/Components/FilterableList/BaseFilterableListContainer");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var index_1 = require("../../index");
var BusinessRules_1 = require("../services/BusinessRules");
var FilterClearService_1 = require("../services/FilterClearService");
var FiltersService_1 = require("../services/FiltersService");
var SearchResultsService_1 = require("../services/SearchResultsService");
var DesktopFilterableListContainer_1 = require("./DesktopFilterableListContainer");
var SearchResultsContainer = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultsContainer, _super);
    function SearchResultsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.isInitialSearchKey = 'isInitialSearch';
        _this.isTitleHidden = function (query) {
            return !query || _this.isStarSearch(query);
        };
        _this.getSelectedFiltersCountWithouPreselected = function (selectedFilters) {
            var service = _this.props.service;
            var preselectedFilters = BusinessRules_1.BusinessRules.getPreselectedFiltersArray(service.config);
            return selectedFilters.reduce(function (count, selectedFilter) {
                if (preselectedFilters.indexOf(selectedFilter) === -1) {
                    count += 1;
                }
                return count;
            }, 0);
        };
        _this.prepareChangedFilters = function (groupValue, _filterValue, filters, selectedFilters, _unselect) {
            if (_unselect === void 0) { _unselect = false; }
            var matchFilterToClearFunction = FilterClearService_1.FilterClearService.getMatchFilterToClearFunction(groupValue, filters, selectedFilters);
            if (matchFilterToClearFunction) {
                return FilterClearService_1.FilterClearService.clearFilters(filters, selectedFilters, matchFilterToClearFunction);
            }
            return { filters: filters, selectedFilters: selectedFilters };
        };
        _this.onDataLoaded = function (filteredData, _initialFilters, selectedFiltersList) {
            var selectedType = (0, search_1.getSelectedFilter)(selectedFiltersList, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias);
            var selectedTypeValue = SearchResultsService_1.SearchResultsService.getFilterValueItself(selectedType);
            var dictionary = index_1.PageContext.dictionary;
            app_1.UrlService.RemoveFromUrl(_this.isInitialSearchKey);
            if (!_this.state.isDesktop) {
                filteredData.filters = FiltersService_1.FiltersService.removeFiltersWithoutValuesMobile(filteredData.filters);
            }
            switch (selectedTypeValue) {
                case FullTextSearchApi_1.FullTextSearcherTypes.Documentation:
                    var documentsHierarchyConfiguration = _this.props.additionalData.documentsHierarchyConfiguration;
                    filteredData = BusinessRules_1.BusinessRules.processHierarchyRules(filteredData, selectedFiltersList, dictionary, documentsHierarchyConfiguration);
                    break;
                case FullTextSearchApi_1.FullTextSearcherTypes.Drawings:
                    var drawingsHierarchyConfiguration = _this.props.additionalData.drawingsHierarchyConfiguration;
                    filteredData = BusinessRules_1.BusinessRules.processHierarchyRules(filteredData, selectedFiltersList, dictionary, drawingsHierarchyConfiguration);
                    break;
                case FullTextSearchApi_1.FullTextSearcherTypes.Download:
                    var downloadHierarchyConfiguration = _this.props.additionalData.downloadHierarchyConfiguration;
                    filteredData = BusinessRules_1.BusinessRules.processHierarchyRules(filteredData, selectedFiltersList, dictionary, downloadHierarchyConfiguration);
                    break;
                case FullTextSearchApi_1.FullTextSearcherTypes.Careers:
                    filteredData = BusinessRules_1.BusinessRules.processCareersLocationRule(filteredData, selectedFiltersList);
                    break;
                case FullTextSearchApi_1.FullTextSearcherTypes.Course:
                    filteredData = BusinessRules_1.BusinessRules.processHierarchyRules(filteredData, selectedFiltersList, dictionary);
                    break;
                case FullTextSearchApi_1.FullTextSearcherTypes.Products:
                    filteredData = BusinessRules_1.BusinessRules.processProductTypeRule(filteredData);
                    break;
            }
            if (_this.props.additionalData.isDocumentsSearchPage) {
                BusinessRules_1.BusinessRules.processDocumentsSearchPageRules(filteredData, _this.props.additionalData.documentsSearchPageType);
            }
        };
        _this.detectBreakpointOnResize = function () {
            _this.setState({ isDesktop: (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.LGScreen) });
        };
        _this.state = {
            isDesktop: (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.LGScreen),
        };
        _this.dataLoader = new FilterableDataLoader_1.FilterableDataLoader({
            dataLoadedSuccessHandler: _this.onDataLoaded,
            pageId: index_1.PageContext.pageId,
            pageName: index_1.PageContext.pageName,
            prepareSelectedFiltersHandler: function (selectedFilters, pageNumber, pageSize, sortBy, subsequentSearch) {
                return FiltersService_1.FiltersService.prepareSelectedFilters(selectedFilters, _this.props.service.config, _this.state.isDesktop, _this.props.additionalData.isDocumentsSearchPage, _this.props.additionalData.documentsSearchPageType, subsequentSearch);
            },
            service: _this.props.service,
            storeFiltersInHistory: true,
        });
        _this.onWindowResize = (0, webexUI_1.throttle)(_this.detectBreakpointOnResize, 100);
        localStorage.setItem('searchApiUrl', _this.props.service.config.searchUrl);
        return _this;
    }
    SearchResultsContainer.prototype.isStarSearch = function (query) {
        var starSearchRegExp = /^\**$/;
        var searchQuery = typeof query === 'undefined' ? app_1.UrlService.GetObjectFromUrlString().query : query;
        return searchQuery && typeof searchQuery === 'string' && starSearchRegExp.test(searchQuery);
    };
    SearchResultsContainer.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
    };
    SearchResultsContainer.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    SearchResultsContainer.prototype.render = function () {
        var _this = this;
        var additionalData = tslib_1.__assign(tslib_1.__assign({}, this.props.additionalData), { pageid: index_1.PageContext.pageId });
        var starSearchEnabled = this.props.service.config.starSearchEnabled;
        var zeroResultsInformation = {
            zeroResultsTitle: additionalData.zeroResultsTitle,
            zeroResultsText: additionalData.zeroResultsText,
        };
        var isDocumentsSearchPage = this.props.additionalData.isDocumentsSearchPage;
        var isStarSearchEnabled = !starSearchEnabled ? this.isStarSearch : null;
        return this.state.isDesktop ? (React.createElement(BaseFilterableListContainer_1.BaseFilterableListContainer, { renderIn: FilterTypings_1.BaseFilterableListParent.SearchResultsListContainer, isDocumentsSearchPage: isDocumentsSearchPage, additionalData: additionalData, dataLoader: this.dataLoader, prepareChangedFiltersHandler: this.prepareChangedFilters, zeroResultGuard: isStarSearchEnabled, isTitleHidden: this.isTitleHidden, customViewComponent: function (state) { return (React.createElement(DesktopFilterableListContainer_1.DesktopFilterableListContainer, { state: state, allResultsLabel: additionalData.allResultsLabel, zeroResultsInformation: zeroResultsInformation, isDocumentsSearchPage: isDocumentsSearchPage, isTitleHidden: _this.isTitleHidden, documentsSearchPageType: additionalData.documentsSearchPageType })); } })) : (React.createElement(BaseFilterableListContainer_1.BaseFilterableListContainer, { renderIn: FilterTypings_1.BaseFilterableListParent.SearchResultsListContainer, isDocumentsSearchPage: isDocumentsSearchPage, additionalData: additionalData, dataLoader: this.dataLoader, prepareChangedFiltersHandler: this.prepareChangedFilters, zeroResultGuard: isStarSearchEnabled, isTitleHidden: this.isTitleHidden, getSelectedFiltersCountWithouPreselected: this.getSelectedFiltersCountWithouPreselected }));
    };
    return SearchResultsContainer;
}(React.Component));
exports.SearchResultsContainer = SearchResultsContainer;
